const data =  {
    city: '',
    entity: '',
    entity_name: '',
    zolo_center_id: '',
    combinedEntityName: '',
    invoice_amount: 0,
    sgst_amount: 0,
    cgst_amount: 0,
    igst_amount: 0,
    ugst_amount: 0,
    tds_deduction: 0,
    deduction_others: 0,
    deduction_remarks: '',
    discount: 0,
    payable_amount: 0,
    entity_nameSearchText: '',
    gst_splits: [{
        amount: 0,
        split_sgst_amount: 0,
        split_cgst_amount: 0,
        split_igst_amount: 0,
        split_ugst_amount: 0,
        gst_slab: '',
        tds_slab: 0,
        tds_deduction: 0,
        other_deduction: 0,
        discount: 0,
        ledger_name: '',
        split_payable_amount: 0,
        quantity: 0,
        rate: 0,
        item_name: '',
        is_recoverable: false,
        recoverable_percentage: 0,
        item_description: '',
        currency: 'INR',
        ledger_name_text: '',
        ldc_amount_limit: 0,
        is_gst_rcm: false,
        hsn:'',
        sac:'',
    }],
    deleted_gst_splits:[]
}
export default data;


// WEBPACK FOOTER //
// ./src/component-data/paymentrequest-data/CostCenterDetails.js